/**
 * 这边前端请求后端接口时，需要再多携带一个header头信息（baseInfo）,对应值格式： 机构id,aospSubUserId,
 * 示例：  (机构端：430552,123  内部端： 0,456, 内部端进机构: xx,456)
 * 场景1: aosp登录进内部: 0,456
 * 场景2: aosp登录进外部(机构端): 453123,456
 * 场景3: 内部用户有外部机构的列表，进入外部端: 453123,456
 *
 * 总结:
 * - 场景1
 * - 场景2与场景3
 * @param options
 */
export default (options) => {
  // options.url = nx.tmpl(options.url, { subject });
  const { token, aospSubUserId, schoolId } = alo7Account;
  const baseinfo = [schoolId || 0, aospSubUserId].join();
  options.headers = nx.mix(options.headers, { baseinfo, authorization: `Bearer ${token}` });
  return options;
};
